<div>
  <div class="content">
    <img id="{{ id }}" class="icon" src="" alt="{{ name }}" />
    <div class="name">{{ name }}</div>
  </div>
  <div class="footer">
    <mat-button-toggle-group [hideSingleSelectionIndicator]="true">
      <mat-button-toggle
        (change)="toggleNone()"
        [value]="isNone"
        [checked]="isNone"
      >
        <span class="toggleButtonTitle">None</span>
      </mat-button-toggle>
      <mat-button-toggle
        [class.activeMatButtonActor]="isActor"
        (change)="toggleActor()"
        [value]="isActor"
        [checked]="isActor"
      >
        <span class="toggleButtonTitle">Actor</span>
      </mat-button-toggle>
      <mat-button-toggle
        [class.activeMatButtonWorkObject]="isWorkobject"
        (change)="toggleWorkobject()"
        [value]="isWorkobject"
        [checked]="isWorkobject"
      >
        <span class="toggleButtonTitle">Work Object</span>
      </mat-button-toggle>
    </mat-button-toggle-group>
  </div>
</div>
